import { render, staticRenderFns } from "./Customform1.vue?vue&type=template&id=be8970cc&"
import script from "./Customform1.vue?vue&type=script&lang=js&"
export * from "./Customform1.vue?vue&type=script&lang=js&"
import style0 from "./Customform1.vue?vue&type=style&index=0&id=be8970cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports